/**
 * Scale a cursor→element-center offset toward the cursor, then radially clamp
 * the resulting pull vector to `max` px so diagonal pulls never exceed `max`.
 * Pure — unit-checked by scripts/check-magnetic.mjs.
 */
export function magneticOffset(
  dx: number,
  dy: number,
  strength: number,
  max: number
): { x: number; y: number } {
  const sx = dx * strength;
  const sy = dy * strength;
  const dist = Math.hypot(sx, sy);
  if (dist <= max || dist === 0) return { x: sx, y: sy };
  const scale = max / dist;
  return { x: sx * scale, y: sy * scale };
}
